import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import useShop from "@saleor/hooks/useShop";
import { commonMessages } from "@saleor/intl";
import { stringify as stringifyQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../misc";
import {
  ComboTranslationInput,
  LanguageCodeEnum
} from "../../types/globalTypes";
import TranslationsComboPage, {
  fieldNames
} from "../components/TranslationsComboPage";
import { TypedUpdateComboTranslations } from "../mutations";
import { TypedComboTranslationDetails } from "../queries";
import { UpdateComboTranslations } from "../types/UpdateComboTranslations";
import {
  // languageEntitiesUrl,
  languageEntityUrl,
  TranslatableEntities
} from "../urls";

export interface TranslationsComboQueryParams {
  activeField: string;
}
export interface TranslationsComboProps {
  id: string;
  languageCode: LanguageCodeEnum;
  params: TranslationsComboQueryParams;
}

const TranslationsCombo: React.FC<TranslationsComboProps> = ({
  id,
  languageCode,
  params
}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const shop = useShop();
  const intl = useIntl();

  const onEdit = (field: string) =>
    navigate(
      "?" +
        stringifyQs({
          activeField: field
        }),
      true
    );
  const onUpdate = (data: UpdateComboTranslations) => {
    if (data.comboTranslate.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage(commonMessages.savedChanges)
      });
      navigate("?", true);
    }
  };
  const onDiscard = () => {
    navigate("?", true);
  };

  return (
    <TypedComboTranslationDetails variables={{ id, language: languageCode }}>
      {pageHeaderTranslations => (
        <TypedUpdateComboTranslations onCompleted={onUpdate}>
          {(updateTranslations, updateTranslationsOpts) => {
            const handleSubmit = (field: string, data: string) => {
              const input: ComboTranslationInput = {};
              if (field === fieldNames.name) {
                input.name = data;
              } else if (field === fieldNames.labelLink) {
                input.labelLink = data;
              } else if (field === fieldNames.labelText) {
                input.labelText = data;
              }
              updateTranslations({
                variables: {
                  id,
                  input,
                  language: languageCode
                }
              });
            };

            return (
              <TranslationsComboPage
                activeField={params.activeField}
                disabled={
                  pageHeaderTranslations.loading ||
                  updateTranslationsOpts.loading
                }
                languageCode={languageCode}
                languages={maybe(() => shop.languages, [])}
                saveButtonState={updateTranslationsOpts.status}
                onBack={() => history.go(-1)}
                onEdit={onEdit}
                onDiscard={onDiscard}
                onLanguageChange={lang =>
                  navigate(
                    languageEntityUrl(lang, TranslatableEntities.combo, id)
                  )
                }
                onSubmit={handleSubmit}
                combo={maybe(() => pageHeaderTranslations.data.comboById)}
              />
            );
          }}
        </TypedUpdateComboTranslations>
      )}
    </TypedComboTranslationDetails>
  );
};
TranslationsCombo.displayName = "TranslationsCombo";
export default TranslationsCombo;
